import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useTheme } from "@mui/material/styles";
import { type FC, useEffect } from "react";
import { TokenPickerV2 } from "../../../../merge-tag/components/token-picker-v2";
import type { TagGroup } from "../../../../merge-tag/components/types";
import { $createMergeTagV2Node } from "../../nodes/merge-tag-node-v2";
import { INSERT_MERGE_TAG_COMMAND } from "../../types/commands";
import { $insertNode } from "../../utils/insert-node";
import type { ToolbarProps } from "./props";

type MergeTagPickerProps = ToolbarProps & { filterTags: (x: string) => TagGroup };
export const MergeTagPicker: FC<MergeTagPickerProps> = ({ disabled, filterTags }) => {
  const [editor] = useLexicalComposerContext();
  const theme = useTheme();

  useEffect(() => {
    return editor.registerCommand(
      INSERT_MERGE_TAG_COMMAND,
      (payload) => {
        const tagBody = payload.slice(2, -2);

        const mergeTagNode = $createMergeTagV2Node(tagBody);
        if (mergeTagNode) $insertNode(mergeTagNode);

        return true;
      },
      1,
    );
  }, [editor, theme]);

  return (
    <TokenPickerV2
      buttonStyle={{ border: "none", "&.Mui-disabled": { border: "none" } }}
      data-testid="toolbar-button-merge-tag"
      disabled={disabled}
      filterTags={filterTags}
      onSelection={(tagId) => {
        editor.dispatchCommand(INSERT_MERGE_TAG_COMMAND, `${tagId}`);
      }}
      editor="lexical"
    />
  );
};
